module.exports = __webpack_public_path__ + "img/step_two_brands.d2a38c44.jpg";